import React, { useCallback, useEffect, useState } from 'react'
import { LIMIT_ALL } from '../../../constants/pagination'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import moment from 'moment'
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

// COMPONENT
import * as styled from '../style/main.style'
import Navbar from '../Navbar'
import Header from '../Header'
import FilterSelect from '../../../component/select/filterSelect'
import InputDatePicker from '../../../component/input/inputDatePicker'
import InputTextField from '../../../component/input/inputTextField'
import { MenuItem, Typography } from '@mui/material'
import { colors } from '../../../constants/colors'
// import { RouteImage } from '../../../assets/routeImage'
import Dropdown from '../../../component/dropdown/Dropdown';
import LabelCustom from '../../../component/label/LabelCustom';
import AutocompleteSelect from '../../../component/select/autoCompleteSelect';
import Loading from '../../../component/loading/Loading';
import { swalSuccess } from '../../../component/notification/swal';
import { numberFormat } from '../../../utils/common';
import { setLoading, unsetLoading } from '../../../store/slice/loading/loading.slice';

// TABS
import { projectTabsProps, indicatorTabsProps, CustomTabPanel, IndicatorCustomTabPanel, CustomTab } from './tabs/createProjectsTabs';
import { formatBudgetFormApi, formatCurrencyData, handleTypingNumber, revertFormatCurrency } from '../../../utils/app.utils';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';

// API
import { DepartMentApi } from '../../../api/department/department.api';
import { ProjectApi, createProject } from '../../../api/project/project.api';
import { FiscalYearApi } from '../../../api/fiscal-year/fiscalyear.api';
import { BudgetApi } from '../../../api/budget/budget.api';
import { EmployeesApi } from '../../../api/employee/Employees.api';
import { TypesApi } from '../../../api/type/type.api';
import { StrategyApi, getStrategy } from '../../../api/strategy/strategy.api';
import { ClustersApi } from '../../../api/clusters/clusters.api';
import { PlanApi } from '../../../api/plan/plan.api';
import { TacticsApi, getTactics } from '../../../api/tactics/tactics.api';
import { IndicatorsApi } from '../../../api/indicators/indicators.api';

// ERROR MESSAGE
import {
    errorNotificationType,
    initStateErrorMessage,
    errorMessageText
} from './type/error-type/error.notification';
import { DetailAccordion, MainAccordion, TopicAccordion } from '../../../component/accordion/accordion.custom';
import { ButtonContained } from '../../../component/mui-custom/MuiCustom';

const ViewProjectInformation = () => {
    // CONSTANT 👇
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const navigate: NavigateFunction = useNavigate()
    const { idProject } = useParams()

    // STATE 👇
    // const [isDisbursement, setIsDisbursement] = useState<boolean>(false);
    const [projectTabs, setProjectTabs] = useState<number>(0);
    const [indicatorTabs, setIndicatorTabs] = useState<number>(0);
    const [isActivity, setIsActivity] = useState<boolean | undefined>(undefined);
    const [hideDetailWorkPeriod, setHideDetailWorkPeriod] = useState<boolean>(false);
    const [hideDetailDisbursement, setHideDetailDisbursement] = useState<boolean>(false);

    const handleChangeProjectTabs = (event: React.SyntheticEvent, newValue: number) => setProjectTabs(newValue)
    const handleChangeIndicatorTabs = (event: React.SyntheticEvent, newValue: number) => setIndicatorTabs(newValue)

    const [idType, setIdType] = useState<number>(Number);
    const [fiscalYear, setFiscalYear] = useState<any[]>([]);
    const [types, setTypes] = useState<any[]>([]);
    const [strategy, setStrategy] = useState<any[]>([]);
    const [tactics, setTactics] = useState<any[]>([]);
    const [plans, setPlans] = useState<any[]>([]);
    const [clusters, setClusters] = useState<any[]>([]);
    const [budgetSource, setBudgetSource] = useState<any[]>([]);
    const [employees, setEmployees] = useState<any[]>([]);
    const [statusId, setStatusId] = useState<number>(50);
    const [department, setDepartment] = useState<any[]>([]);
    const [idDepartment, setIdDepartment] = useState<number | null>(null);
    const [indicators, setIndicators] = useState<any[]>([])
    const [projectDetail, setProjectDetail] = useState<any>(null)
    const [detailExtension, setDetailExtension] = useState<any[]>([]);
    const [projectStatus, setProjectStatus] = useState<any[]>([]);
    // const [expansionMostEndDate, setExpansionMostEndDate] = useState<Date | string>("");
    const [isPublic, setIsPublic] = useState<boolean>(false);

    const [errorMessage, setErrorMessage] = useState<errorNotificationType>(initStateErrorMessage)

    const [formProject, setFormProject] = useState<createProject>({
        idDepartment: null,
        idFiscalYear: null,
        idStrategy: null,
        idPlan: null,
        idClusters: 0,
        projectName: "",
        idType: null,
        idStatus: 0,
        idMainResponsible: 0,
        idTactics: 0,
        isPublic: false,
        percentMainResponsible: 0,
        projectStatus: t("STATUS.ACTIVE"),
        projectDesc: "",
        projectEndDate: "",
        projectStartDate: "",
        detailWorkPeriod: [
            {
                startDate: "",
                endDate: "",
            }
        ],
        detailDisbursement: [
            {
                endDate: "",
                budget: "",
                paid: "",
                unpaid: "",
            }
        ],
        detailBudget: [
            {
                idBudget: 0,
                projectBudget: 0,
                equipmentBudget: 0,
                extraBudget: 0,
                reducedBudget: 0,
                remark: "",
                sumBudget: ""
            }
        ],
        detailResponsible: [],
        detailIndicators: [
            {
                idIndicators: 1,
                indicatorsName: "",
                max1: 0,
                max2: 0,
                max3: 0,
                max4: 0,
                max5: 0,
                min1: 0,
                min2: 0,
                min3: 0,
                min4: 0,
                min5: 0,
                description1: "",
                description2: "",
                description3: "",
                description4: "",
                description5: "",
                percent: 0
            }
        ],
        tabs: [{
            detailBudget: [
                {
                    equipmentBudget: "",
                    extraBudget: "",
                    idBudget: null,
                    projectBudget: "",
                    reducedBudget: "",
                    remark: "",
                    sumBudget: ""
                }
            ],
            detailDisbursement: [
                {
                    endDate: "",
                    budget: "",
                    paid: "",
                    unpaid: "",
                }
            ],
            detailResponsible: [
                {
                    idEmployee: 0,
                    percent: null
                }
            ],
            detailWorkPeriod: [
                {
                    endDate: "",
                    startDate: ""
                }
            ],
            detailIndicators: [{
                idIndicators: undefined,
                indicatorsName: "",
                max1: 0,
                max2: 0,
                max3: 0,
                max4: 0,
                max5: 0,
                min1: 0,
                min2: 0,
                min3: 0,
                min4: 0,
                min5: 0,
                description1: "",
                description2: "",
                description3: "",
                description4: "",
                description5: "",
                percent: 0
            }]
        }]
    })



    const handleGetProject = async () => {
        dispatch(setLoading())
        await ProjectApi.getDetailProject(Number(idProject))
            .then(res => {
                if (res.status === 200) {
                    const data = res.data?.result
                    if (data) {
                        setIsPublic(data?.isPublic ? true : false)
                        setIdType(data?.idType)
                        setProjectDetail(data);
                        dispatch(unsetLoading())
                        setIdDepartment(data?.idDepartment)
                        setDetailExtension(data?.detailExtension)

                        const sumPaidDetailDisbursement = data?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.paid), 0) || 0;
                        const sumPaidDetailActivities = data?.detailActivities?.reduce((a: any, b: any) =>
                            a + (b.detailDisbursement?.reduce((m: any, n: any) => m + Number(n?.paid), 0) || 0), 0) || 0;
                        const sumUnpaidDetailDisbursement = data?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.unpaid), 0) || 0;
                        const sumUnpaidDetailActivities = data?.detailActivities?.reduce((a: any, b: any) =>
                            a + (b.detailDisbursement?.reduce((m: any, n: any) => m + Number(n?.unpaid), 0) || 0), 0) || 0;

                        const totalSumAllBudget = data?.detailBudget?.reduce((a: any, b: any) => a + Number(b?.sumBudget), 0) || 0;
                        const totalSumAllPaid = sumPaidDetailDisbursement + sumPaidDetailActivities || 0;
                        const totalSumAllUnpaid = sumUnpaidDetailDisbursement + sumUnpaidDetailActivities || 0;

                        setFormProject((prev) => {
                            const mainData: any = {
                                sumAllBudget: formatCurrencyData(totalSumAllBudget.toString(), 'revert'),
                                sumAllPaid: formatCurrencyData(totalSumAllPaid.toString(), 'revert'),
                                sumAllUnpaid: formatCurrencyData(totalSumAllUnpaid.toString(), 'revert'),
                                projectDesc: data?.projectDesc,
                                detailWorkPeriod: [...data?.detailWorkPeriod],
                                detailDisbursement: data?.detailDisbursement?.map((list: any) => ({
                                    ...list,
                                    ['budget']: formatBudgetFormApi(list?.budget),
                                    ['paid']: formatBudgetFormApi(list?.paid),
                                    ['unpaid']: formatBudgetFormApi(list?.unpaid),
                                })),
                                detailBudget: data?.detailBudget?.map((list: any) => (
                                    {
                                        ...list,
                                        ['projectBudget']: formatBudgetFormApi(list?.projectBudget),
                                        ['reducedBudget']: formatBudgetFormApi(list?.reducedBudget),
                                        ['equipmentBudget']: formatBudgetFormApi(list?.equipmentBudget),
                                        ['extraBudget']: formatBudgetFormApi(list?.extraBudget),
                                        ['sumBudget']: formatBudgetFormApi(list?.sumBudget)
                                    })),
                                detailResponsible: data?.detailResponsible?.map((list: any) => ({
                                    ...list,
                                    ['percent']: parseFloat(list?.percent)
                                })),
                                detailIndicators: data?.detailIndicators?.map((list: any) => ({
                                    ...list,
                                    ['max1']: parseFloat(list?.max1),
                                    ['max2']: parseFloat(list?.max2),
                                    ['max3']: parseFloat(list?.max3),
                                    ['max4']: parseFloat(list?.max4),
                                    ['max5']: parseFloat(list?.max5),
                                    ['min1']: parseFloat(list?.min1),
                                    ['min2']: parseFloat(list?.min2),
                                    ['min3']: parseFloat(list?.min3),
                                    ['min4']: parseFloat(list?.min4),
                                    ['min5']: parseFloat(list?.min5),
                                    ['percent']: parseFloat(list?.percent)

                                })),
                                detailActivities: [...data?.detailActivities]
                            }
                            const activityData: any = data?.detailActivities?.map((detail: any) => ({
                                ...detail,
                                sumAllBudget: formatCurrencyData(detail?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y.budget), 0).toString(), 'revert'),
                                sumAllPaid: formatCurrencyData(detail?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.paid), 0).toString(), 'revert'),
                                sumAllUnpaid: formatCurrencyData(detail?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.unpaid), 0).toString(), 'revert'),
                                detailDisbursement: detail?.detailDisbursement?.map((list: any) => ({
                                    ...list,
                                    ['budget']: formatBudgetFormApi(list?.budget),
                                    ['paid']: formatBudgetFormApi(list?.paid),
                                    ['unpaid']: formatBudgetFormApi(list?.unpaid),
                                })),
                                detailBudget: [],
                                detailResponsible: detail?.detailResponsible?.map((list: any) => ({
                                    ...list,
                                    ['percent']: parseFloat(list?.percent)
                                })),
                                detailIndicators: detail?.detailIndicators?.map((list: any) => ({
                                    ...list,
                                    ['indicatorsName']: list?.indicators?.indicatorsName,
                                    ['max1']: parseFloat(list?.max1),
                                    ['max2']: parseFloat(list?.max2),
                                    ['max3']: parseFloat(list?.max3),
                                    ['max4']: parseFloat(list?.max4),
                                    ['max5']: parseFloat(list?.max5),
                                    ['min1']: parseFloat(list?.min1),
                                    ['min2']: parseFloat(list?.min2),
                                    ['min3']: parseFloat(list?.min3),
                                    ['min4']: parseFloat(list?.min4),
                                    ['min5']: parseFloat(list?.min5),
                                    ['percent']: parseFloat(list?.percent)
                                })),
                            }))
                            return {
                                ...prev,
                                idDepartment: data?.idDepartment,
                                idFiscalYear: data?.idFiscalYear,
                                idStrategy: data?.idStrategy,
                                idTactics: data?.idTactics,
                                idPlan: data?.idPlan,
                                projectStartDate: data?.projectStartDate,
                                projectEndDate: data?.projectEndDate,
                                projectName: data?.projectName,
                                idClusters: data?.idClusters,
                                idType: data?.idType,
                                idMainResponsible: data?.idMainResponsible,
                                percentMainResponsible: data?.percentMainResponsible,
                                idStatus: data?.idStatus,
                                tabs: [mainData, ...activityData],
                            }
                        })
                    }
                } else {
                    dispatch(unsetLoading())
                    navigate(-1)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const handleGetProjectStatus = async () => {
        const condition = {
            idType: idType
        }
        await ProjectApi.getProjectStatus(condition)
            .then(res => {
                if (res.status === 200) {
                    setProjectStatus(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {
        handleGetProjectStatus()
    }, [idType])

    useEffect(() => {
        handleGetProject();
    }, [])

    // console.log(formProject)

    console.log(formProject?.isPublic)

    // ผู้รับผิดชอบโครงการ
    const handleChangeDetailResponsible = (name: string, indexDetail: number, indexMain: number, value?: any) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, index: number) => {
                    if (index === indexMain) {
                        return {
                            ...list,
                            detailResponsible: list.detailResponsible.map((detail, i: number) => {
                                if (i === indexDetail) {
                                    return {
                                        ...detail,
                                        [name]: value ? value : Number(event.target.value) > 100 ? 0 : Number(event.target?.value)
                                    }
                                } else {
                                    return {
                                        ...detail
                                    }
                                }
                            })
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }

    // API
    const handleGetFiscalYear = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setFiscalYear(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const handleGetType = useCallback(async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (formProject.idFiscalYear) condition = { ...condition, idFiscalYear: formProject.idFiscalYear }
        await TypesApi.getType(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result)
                    setTypes(res.data?.result?.items);
                    const isActivityStatus = res.data?.result?.items?.find((list: any) => list?.idType === formProject.idType)?.isActivities
                    isActivityStatus && setIsActivity(!!isActivityStatus)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [formProject.idFiscalYear])
    const handleGetStrategy = useCallback(async () => {
        let condition: getStrategy = { limit: LIMIT_ALL }
        if (formProject.idFiscalYear) condition = { ...condition, idFiscalYear: formProject.idFiscalYear }
        await StrategyApi.getStrategy(condition)
            .then(res => {
                if (res.status === 200) {
                    setStrategy(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [formProject.idFiscalYear])
    const handleGetTactics = useCallback(async () => {
        let condition: getTactics = { limit: LIMIT_ALL }
        if (formProject.idStrategy) condition = { ...condition, idStrategy: formProject.idStrategy }
        await TacticsApi.getTactics(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setTactics(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [formProject.idStrategy, formProject.idFiscalYear])
    const handleGetPlan = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await PlanApi.getPlans(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setPlans(res.data?.result?.items)

                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetClusters = async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (formProject.idFiscalYear) condition = { ...condition, idFiscalYear: formProject.idFiscalYear }
        await ClustersApi.getClusters(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setClusters(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetBudgetSource = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await BudgetApi.getBudgets(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setBudgetSource(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetEmployees = async () => {
        let condition: any = {
            page: 1,
            limit: 100000
        }
        await EmployeesApi.getEmployees(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setEmployees(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetIndicators = async () => {
        let condition: any = {}
        await IndicatorsApi.GetIndicators(condition)
            .then(res => {
                if (res.status === 200) {
                    setIndicators(res.data?.result?.items)
                }
            })
            .catch(error => {
                // throw new error
                console.log(error)
            })
    }

    const validateForm = () => {
        let hasErrors = false;
        if (!idDepartment) {
            setErrorMessage((prev) => ({ ...prev, ID_DEPARTMENT: errorMessageText.ID_DEPARTMENT }));
            hasErrors = true;
        }
        if (!formProject.idFiscalYear) {
            setErrorMessage((prev) => ({ ...prev, ID_FISCAL_YEAR: errorMessageText.ID_FISCAL_YEAR }));
            hasErrors = true;
        }
        if (!formProject.idStrategy) {
            setErrorMessage((prev) => ({ ...prev, ID_STRATEGY: errorMessageText.ID_STRATEGY }));
            hasErrors = true;
        }
        if (!formProject.idTactics) {
            setErrorMessage((prev) => ({ ...prev, ID_TACTICS: errorMessageText.ID_TACTICS }));
            hasErrors = true;
        }
        if (!formProject.idPlan) {
            setErrorMessage((prev) => ({ ...prev, ID_PLAN: errorMessageText.ID_PLAN }));
            hasErrors = true;
        }
        if (!formProject.projectStartDate) {
            setErrorMessage((prev) => ({ ...prev, START_DATE_PROJECT: errorMessageText.START_DATE_PROJECT }));
            hasErrors = true;
        }
        if (!formProject.projectName) {
            setErrorMessage((prev) => ({ ...prev, PROJECT_NAME: errorMessageText.PROJECT_NAME }));
            hasErrors = true;
        }
        if (!formProject.idType) {
            setErrorMessage((prev) => ({ ...prev, ID_TYPE: errorMessageText.ID_TYPE }));
            hasErrors = true;
        }
        if (!formProject.idClusters) {
            setErrorMessage((prev) => ({ ...prev, ID_CLUSTERS: errorMessageText.ID_CLUSTERS }));
            hasErrors = true;
        }
        formProject.detailDisbursement.map((list) => {
            if (!list.budget) {
                setErrorMessage((prev) => ({ ...prev, BUDGET: errorMessageText.BUDGET }))
                return !hasErrors
            }
        })
        formProject.tabs.map((data) => {
            return {
                ...data,
                detailBudget: data.detailBudget.map((list) => {
                    if (!list.idBudget) {
                        setErrorMessage((prev) => ({ ...prev, ID_BUDGET: errorMessageText.ID_BUDGET }))
                        return !hasErrors
                    } else {
                        return hasErrors
                    }
                })

            }
        })
        return !hasErrors;
    };

    const handleSubmitForm = async (event: React.FormEvent) => {
        event.preventDefault();
        const validated = validateForm()
        let condition: any = {
            idDepartment: formProject.idDepartment || idDepartment,
            projectName: formProject.projectName,
            projectDesc: formProject.tabs[0]?.projectDesc,
            idFiscalYear: formProject.idFiscalYear,
            idStrategy: formProject.idStrategy,
            idTactics: formProject.idTactics,
            idPlan: formProject.idPlan,
            idType: formProject.idType,
            idStatus: statusId,
            isPublic: formProject.isPublic,
            idClusters: formProject.idClusters,
            idMainResponsible: formProject.tabs[0]?.detailResponsible[0]?.idEmployee,
            percentMainResponsible: formProject.tabs[0]?.detailResponsible[0]?.percent,
            projectStartDate: formProject.projectStartDate,
            projectEndDate: formProject.projectEndDate,
            projectStatus: formProject.projectStatus,
            detailWorkPeriod: formProject.tabs[0]?.detailWorkPeriod,
            detailDisbursement: formProject.tabs[0]?.detailDisbursement.map((list) => ({ ...list, budget: revertFormatCurrency(list.budget.toString()), paid: revertFormatCurrency(list.paid.toString()), unpaid: revertFormatCurrency(list.unpaid.toString()) })),
            detailBudget: formProject.tabs[0]?.detailBudget.map((list) => ({ ...list, equipmentBudget: revertFormatCurrency(list.equipmentBudget.toString()), extraBudget: revertFormatCurrency(list.extraBudget.toString()), projectBudget: revertFormatCurrency(list.projectBudget.toString()), reducedBudget: revertFormatCurrency(list.reducedBudget.toString()), sumBudget: revertFormatCurrency(list.sumBudget.toString()) })),
            detailResponsible: formProject.tabs[0]?.detailResponsible,
            detailIndicators: formProject.tabs[0]?.detailIndicators,
            detailActivities: !isActivity ? [] : formProject.tabs.slice(1, formProject.tabs.length).map((list) => {
                return {
                    projectActivitiesName: list.projectActivitiesName,
                    projectActivitiesDesc: list.projectDesc,
                    idMainResponsible: formProject.tabs[0]?.detailResponsible[0]?.idEmployee,
                    percentMainResponsible: formProject.tabs[0]?.detailResponsible[0]?.percent,
                    detailWorkPeriod: [...list.detailWorkPeriod],
                    detailDisbursement: list.detailDisbursement.map((list) => ({ ...list, budget: revertFormatCurrency(list.budget.toString()), paid: revertFormatCurrency(list.paid.toString()), unpaid: revertFormatCurrency(list.unpaid.toString()) })),
                    detailResponsible: [...list.detailResponsible],
                    detailIndicators: [...list.detailIndicators]
                }
            })
        }
        if (!validated) {
            return false
        } else {
            console.log(condition)
            dispatch(setLoading())
            await ProjectApi.createProject(condition)
                .then(res => {
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        swalSuccess(res.data?.description)
                        navigate(-1)
                    }
                })
                .catch(error => {
                    dispatch(unsetLoading())
                    console.log(error)
                })
                .finally(() => dispatch(unsetLoading()))
        }
    }
    const handleGetDepartment = async () => {
        await DepartMentApi.getDetailDepartment(1)
            .then(res => {
                if (res.status === 200) {
                    setDepartment(res.data?.result?.departmentList)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const clearErrorMessage = () => {
        setErrorMessage(initStateErrorMessage)
    }

    useEffect(() => {
        handleGetTactics();
    }, [formProject.idStrategy, formProject.idFiscalYear])

    useEffect(() => {
        handleGetClusters();
        handleGetType();
        handleGetStrategy();
    }, [formProject.idFiscalYear])

    useEffect(() => {
        handleGetFiscalYear()
        handleGetPlan();
        handleGetBudgetSource();
        handleGetEmployees();
        handleGetDepartment();
        handleGetIndicators();
    }, [])
    useEffect(() => {
        setProjectTabs(0)
        setIndicatorTabs(0)
    }, [formProject.idType])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <form className='w-full' onSubmit={handleSubmitForm}>
                        <motion.section
                            className='flex flex-col gap-y-[20px]'
                            initial={{ x: 100 }}
                            animate={{ x: 0 }}
                            transition={{ duration: .4, delay: .1 }}>
                            {/* BUTTON */}
                            <article className='w-full gap-3 flex items-start md:items-center flex-col md:flex-row justify-between'>
                                <span>
                                    <Typography className='text-primary' variant='h4'>
                                        {t("รายละเอียดโครงการ")}
                                    </Typography>
                                </span>
                                <span>
                                    <ButtonContained
                                        sx={{
                                            width: 180,
                                            backgroundColor: colors.lampang_button_secondary,
                                            '&:hover': {
                                                backgroundColor: colors.lampang_button_secondary,
                                                border: `1px solid ${colors.lampang_button_secondary}`
                                            }
                                        }}
                                        variant='contained'>
                                        <Typography variant='body1'>
                                            {isPublic ? "เผยแพร่โครงการแล้ว" : 'ยังไม่เผยแพร่โครงการ'}
                                        </Typography>
                                    </ButtonContained>
                                </span>
                            </article>
                            {/* FILTER */}
                            <article className='grid grid-cols-12 gap-2 mt-8'>
                                <div className='col-span-12'>
                                    <FilterSelect
                                        disabled
                                        onInvalid={() => validateForm()}
                                        required
                                        heading={t("หน่วยงาน")}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-status"
                                        value={idDepartment}
                                        labelId="label-status"
                                        onchange={(event) => {
                                            const value = event.target.value
                                            setIdDepartment(Number(value))
                                            clearErrorMessage()
                                        }}
                                        helperText={errorMessage.ID_DEPARTMENT}
                                        options={department && department?.map((list: any) => (
                                            <MenuItem key={list?.idDepartment} value={list?.idDepartment}>
                                                {list?.departmentName}
                                            </MenuItem>
                                        ))}
                                    />
                                </div>
                            </article>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12 md:col-span-3'>
                                    {fiscalYear && (
                                        <FilterSelect
                                            disabled
                                            onInvalid={() => validateForm()}
                                            required
                                            heading={t("ปีงบประมาณ")}
                                            label={t('STATUS.LABEL')}
                                            selectId="select-fiscal-year"
                                            value={formProject.idFiscalYear}
                                            helperText={errorMessage.ID_FISCAL_YEAR}
                                            labelId="label-fiscal-year"
                                            onchange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                                                const value = event.target.value
                                                value && setFormProject((prev) => ({
                                                    ...prev,
                                                    idTactics: null,
                                                    idFiscalYear: Number(value)
                                                }))
                                                clearErrorMessage()
                                            }}
                                            options={fiscalYear.map((list: any) => (
                                                <MenuItem
                                                    disabled={list?.fiscalYearStatus === t("STATUS.INACTIVE") && true}
                                                    key={list?.idFiscalYear}
                                                    value={list?.idFiscalYear}
                                                >
                                                    <Typography>{list?.fiscalYear}</Typography>
                                                </MenuItem>
                                            ))}
                                        />
                                    )}
                                </div>
                                <div className='col-span-12 md:col-span-9'>
                                    <FilterSelect
                                        disabled
                                        onInvalid={() => validateForm()}
                                        required
                                        heading={t("ยุทธศาสตร์")}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-setStrategy"
                                        value={formProject.idStrategy}
                                        helperText={errorMessage.ID_STRATEGY}
                                        labelId="label-setStrategy"
                                        onchange={(event) => {
                                            const value = event.target.value
                                            value && setFormProject((prev) => ({ ...prev, idStrategy: Number(value) }))
                                            clearErrorMessage()
                                        }}
                                        options={strategy && strategy.map((list: any) => (
                                            <MenuItem key={list?.idStrategy} value={list?.idStrategy} >
                                                {list?.strategyName}
                                            </MenuItem>
                                        ))}
                                    />
                                </div>
                            </article>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12 lg:col-span-5'>
                                    <FilterSelect
                                        disabled
                                        onInvalid={() => validateForm()}
                                        required
                                        heading={t("กลยุทธ์")}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-tacticsId"
                                        value={formProject.idTactics}
                                        helperText={errorMessage.ID_TACTICS}
                                        labelId="label-tacticsId"
                                        onchange={(event) => {
                                            const value = event.target.value
                                            value && setFormProject((prev) => ({ ...prev, idTactics: Number(value) }))
                                            clearErrorMessage()
                                        }}
                                        options={tactics && tactics.map((list: any) => (
                                            <MenuItem key={list?.idTactics} value={list?.idTactics} >
                                                {list?.tacticsName}
                                            </MenuItem>
                                        ))}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-3'>
                                    <FilterSelect
                                        disabled
                                        onInvalid={() => validateForm()}
                                        required
                                        heading={t("แผนงาน")}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-plan"
                                        helperText={errorMessage.ID_PLAN}
                                        value={formProject.idPlan}
                                        labelId="label-plan"
                                        onchange={(event) => {
                                            const value = event.target.value
                                            value && setFormProject((prev) => ({ ...prev, idPlan: Number(value) }))
                                            clearErrorMessage()
                                        }}
                                        options={plans && plans.map((list: any) => (
                                            <MenuItem value={list?.idPlan} key={list?.idPlan} >
                                                {list?.planName}
                                            </MenuItem>
                                        ))}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-2 flex justify-center items-start flex-col relative'>
                                    <InputDatePicker
                                        disabled
                                        helperText={errorMessage.START_DATE_PROJECT}
                                        disableEndDate={formProject.projectEndDate}
                                        inputName='startProject'
                                        inputHeight={42}
                                        dateFormat="DD/MM/YYYY"
                                        required={true}
                                        key={"START_PROJECT"}
                                        value={formProject.projectStartDate}
                                        placeholder={t('ระบุวันเริ่มต้นโครงการ')}
                                        onChange={() => { }}
                                        heading={t("เริ่มต้นโครงการ")}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-2 flex justify-center items-start flex-col relative'>
                                    <InputDatePicker
                                        disabled
                                        disableStartDate={formProject.projectStartDate}
                                        inputName='endProject'
                                        inputHeight={42}
                                        dateFormat="DD/MM/YYYY"
                                        required={true}
                                        key={"END_PROJECT"}
                                        value={formProject.projectEndDate}
                                        placeholder={t('ระบุวันสิ้นสุดโครงการ')}
                                        onChange={() => { }}
                                        heading={t("สิ้นสุดโครงการ")}
                                    />
                                </div>
                            </article>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12'>
                                    <InputTextField
                                        disabled
                                        onInvalid={() => validateForm()}
                                        helperText={errorMessage.PROJECT_NAME}
                                        required
                                        value={formProject.projectName}
                                        heading={t("ชื่อโครงการ")}
                                        onchange={() => { }}
                                    />
                                </div>
                            </article>

                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12 lg:col-span-3'>
                                    <FilterSelect
                                        required
                                        disabled
                                        helperText={errorMessage.ID_TYPE}
                                        onInvalid={() => validateForm()}
                                        heading={t("ประเภทโครงการ")}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-project-type"
                                        value={formProject.idType}
                                        labelId="label-project-type"
                                        onchange={() => { }}
                                        options={types && types.map((list: any) => (
                                            <MenuItem key={list?.idType} value={list?.idType} >
                                                {list?.typeName}
                                            </MenuItem>
                                        ))}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-4'>
                                    <FilterSelect
                                        disabled
                                        onInvalid={() => validateForm()}
                                        required
                                        heading={t("ประเภทกลุ่มภารกิจ (CLUSTERS)")}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-project-name"
                                        value={formProject.idClusters}
                                        labelId="label-project-name"
                                        helperText={errorMessage.ID_CLUSTERS}
                                        onchange={() => { }}
                                        options={clusters && clusters.map((list: any) => (
                                            <MenuItem key={list?.idClusters} value={list?.idClusters}  >
                                                {list?.clustersName}
                                            </MenuItem>
                                        ))}
                                    />
                                </div>
                            </article>

                            {/* ขยายระยะเวลาโครงการ */}
                            {projectDetail
                                // && projectDetail?.statusPercent === 100
                                // && !projectDetail?.isClosed
                                && detailExtension?.length > 0
                                && (
                                    <article className='w-full'>
                                        <MainAccordion defaultExpanded>
                                            <TopicAccordion
                                                expandIcon={<Dropdown />}
                                            >
                                                <span className='w-full'>
                                                    <Typography variant='h6'>
                                                        ขยายระยะเวลาโครงการ
                                                    </Typography>
                                                </span>
                                            </TopicAccordion>
                                            {detailExtension && detailExtension?.map((extension, detailIndex: number) => {
                                                return (
                                                    <DetailAccordion sx={{ mt: 1 }} key={detailIndex}>
                                                        <div className="grid grid-cols-12 gap-2">
                                                            <span className='col-span-12 md:col-span-2 lg:col-span-1 self-center'>
                                                                <Typography className="text-primary">
                                                                    {`ครั้งที่ ${detailIndex + 1}`}
                                                                </Typography>
                                                            </span>
                                                            <span className='col-span-12 md:col-span-12 lg:col-span-4'>
                                                                <AutocompleteSelect
                                                                    onChange={() => { }}
                                                                    disabled
                                                                    value={projectStatus?.find((data: any) => data?.idStatus === extension.startFromIdStatus) || null}
                                                                    getOptionLabel={(option) => option?.projectStatusName}
                                                                    labelId='STATUS_AFTER_DATE'
                                                                    options={projectStatus || []}
                                                                    heading='สถานะโครงการเริ่มต้นหลังขยายระยะเวลาโครงการ'
                                                                />
                                                            </span>
                                                            <span className="col-span-12 md:col-span-12 lg:col-span-3">
                                                                <InputDatePicker
                                                                    disabled
                                                                    placeholder='ระบุวันที่'
                                                                    onChange={() => { }}
                                                                    value={extension?.newEndDate}
                                                                    heading='วันสิ้นสุดการขยายระยะเวลาโครงการ'
                                                                />
                                                            </span>
                                                        </div>
                                                    </DetailAccordion>
                                                )
                                            })}
                                        </MainAccordion>


                                    </article>
                                )}


                            {/* 👇 แสดงข้อมูลเป็น tabs แค่ประเภททั่วไป -> ประเภททั่วไป*/}
                            <article className='w-full'>
                                <Box sx={{ width: '100%' }}>
                                    <Box
                                        style={{ display: isActivity ? '' : "none" }}
                                        className='w-full flex flex-col justify-start items-start gap-2 md:flex-row md:justify-between md:items-end overflow-auto'>
                                        <Tabs
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            TabIndicatorProps={{
                                                sx: {
                                                    backgroundColor: colors.white,
                                                    display: "flex",
                                                    flexWrap: "wrap"
                                                }
                                            }}
                                            value={projectTabs}
                                            onChange={handleChangeProjectTabs}
                                            aria-label="project-tabs"
                                        >
                                            {formProject.tabs?.map((list, index: number) => (
                                                <CustomTab
                                                    key={index}
                                                    className='relative'
                                                    label={
                                                        <div>
                                                            <Typography>
                                                                {index === 0 ? "โครงการหลัก" : `กิจกรรม${index}`}
                                                            </Typography>
                                                        </div>
                                                    }
                                                    {...projectTabsProps(index)}
                                                />
                                            ))}
                                        </Tabs>
                                    </Box>
                                    <div className={`mt-2 ${isActivity && 'bg-bg_secondary'}`}>
                                        {formProject.tabs.map((list, index: number) => (
                                            <CustomTabPanel
                                                key={index}
                                                value={projectTabs}
                                                index={index}>
                                                {index !== 0 && (
                                                    <div>
                                                        <InputTextField
                                                            disabled
                                                            onchange={() => { }}
                                                            required
                                                            value={list.projectActivitiesName}
                                                            heading='ชื่อกิจกรรม'
                                                        />
                                                    </div>
                                                )}

                                                <MainAccordion
                                                    defaultExpanded
                                                >
                                                    <TopicAccordion
                                                        expandIcon={<Dropdown />}
                                                    >
                                                        <section className={`w-full flex ${hideDetailWorkPeriod && 'py-1'}`}>
                                                            <LabelCustom
                                                                variant='h6'
                                                                isRequired={isActivity ? false : true}
                                                                text='งวดความคืบหน้าโครงการ'
                                                            />
                                                        </section>
                                                    </TopicAccordion>
                                                    <DetailAccordion>
                                                        {/* งวดความคืบหน้าโครงการ */}
                                                        {list.detailWorkPeriod?.map((subList, i: number) => (
                                                            <motion.section
                                                                key={i}
                                                                className={`w-full ${hideDetailWorkPeriod && 'hidden'}`}>
                                                                <article className='flex items-center justify-between'>
                                                                    <LabelCustom
                                                                        className='mt-2'
                                                                        text={t(`งวดที่ ${i + 1} ภายในวันที่`)}
                                                                        variant='body1'
                                                                    />
                                                                </article>
                                                                <article className="mt-2 grid grid-cols-12 gap-2">
                                                                    <div className='col-span-12 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            disableEndDate={formProject.projectEndDate}
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            required={isActivity ? false : true}
                                                                            key={"START_PROJECT"}
                                                                            value={subList.startDate}
                                                                            placeholder={t('ระบุวันเริ่มต้นงวด')}
                                                                            onChange={() => { }}
                                                                            heading={t("เริ่มต้น")}
                                                                        />
                                                                    </div>
                                                                    <div className='col-span-12 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            required={isActivity ? false : true}
                                                                            key={"END_PROJECT"}
                                                                            value={subList.endDate}
                                                                            placeholder={t('ระบุวันสิ้นสุดงวด')}
                                                                            onChange={() => { }}
                                                                            heading={t("สิ้นสุด")}
                                                                        />
                                                                    </div>
                                                                </article>
                                                            </motion.section>
                                                        ))}
                                                    </DetailAccordion>
                                                </MainAccordion>


                                                {/* งวดเบิกจ่าย  👇 */}
                                                <section className='w-full mt-2'>
                                                    <article className='w-full'>
                                                        <MainAccordion
                                                            defaultExpanded
                                                        >
                                                            <TopicAccordion
                                                                expandIcon={<Dropdown />}
                                                            >
                                                                <LabelCustom
                                                                    variant='h6'
                                                                    text='งวดเบิกจ่าย'
                                                                    isRequired={isActivity ? false : true}
                                                                />
                                                            </TopicAccordion>
                                                            <DetailAccordion>
                                                                <div className={`content grid grid-cols-12 gap-2 duration-100 w-full`}>
                                                                    {list.detailDisbursement?.map((subList, i: number) => (
                                                                        <motion.div
                                                                            className='contents'
                                                                            initial={{ y: -50 }}
                                                                            animate={{ y: 0 }}
                                                                            transition={{ ease: "easeInOut", stiffness: 40 }}
                                                                            key={i}>
                                                                            <div className='col-span-12 lg:col-span-2'>
                                                                                <InputDatePicker
                                                                                    disabled
                                                                                    disableStartDate={formProject.projectStartDate}
                                                                                    disableEndDate={formProject.projectEndDate}
                                                                                    inputName='startProject'
                                                                                    inputHeight={42}
                                                                                    dateFormat="DD/MM/YYYY"
                                                                                    required={isActivity ? false : true}
                                                                                    key={"START_PROJECT"}
                                                                                    value={subList.endDate}
                                                                                    placeholder={t('ระบุวันที่')}
                                                                                    onChange={() => { }}
                                                                                    heading={`งวดที่ ${i + 1} ภายในวันที่`}
                                                                                />
                                                                            </div>
                                                                            {index === 0 && (
                                                                                <div className='col-span-12 lg:col-span-2'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        placeholder='0.00'
                                                                                        required={isActivity ? false : true}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        onchange={() => { }}
                                                                                        value={subList.budget}
                                                                                        heading={t("งบประมาณรวม (บาท)")}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className='col-span-12 lg:col-span-2'>
                                                                                <InputTextField
                                                                                    disabled
                                                                                    placeholder='0.00'
                                                                                    required={isActivity ? false : true}
                                                                                    onkeypress={handleTypingNumber}
                                                                                    onchange={() => { }}
                                                                                    value={subList.paid}
                                                                                    heading={t("ยอดเบิกจ่ายรวม (บาท)")}
                                                                                />
                                                                            </div>
                                                                            {index === 0 && (
                                                                                <div className='col-span-12 lg:col-span-3'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        placeholder='0.00'
                                                                                        required={isActivity ? false : true}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        onchange={() => { }}
                                                                                        value={subList.unpaid}
                                                                                        heading={t("ยอดงบประมาณค้างเบิก (บาท)")}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className={`col-span-12 ${index === 0 ? 'lg:col-span-2' : 'lg:col-span-7'}`}>

                                                                            </div>
                                                                        </motion.div>
                                                                    ))}
                                                                </div>
                                                            </DetailAccordion>
                                                        </MainAccordion>
                                                    </article>
                                                </section>


                                                {/* แหล่งงงบประมาณ  👇 */}
                                                {index === 0 && (
                                                    <section className='w-full mt-2'>
                                                        <MainAccordion
                                                            defaultExpanded
                                                        >
                                                            <TopicAccordion
                                                                expandIcon={<Dropdown />}
                                                            >
                                                                <LabelCustom
                                                                    variant='h6'
                                                                    text={t("แหล่งงบประมาณ")}
                                                                />
                                                            </TopicAccordion>
                                                            <DetailAccordion>

                                                                {list.detailBudget?.map((budget, i: number) => (
                                                                    <div key={i} className={`${hideDetailDisbursement && 'hidden'}`}>
                                                                        <article className='grid grid-cols-12 mt-2'>
                                                                            <div className='col-span-12 lg:col-span-4'>
                                                                                <FilterSelect
                                                                                    required
                                                                                    disabled
                                                                                    heading={t("แหล่งที่มาของงบประมาณ")}
                                                                                    label={t('STATUS.LABEL')}
                                                                                    selectId="select-budget-source"
                                                                                    value={budget?.idBudget}
                                                                                    labelId="label-budget-source"
                                                                                    onchange={() => { }}
                                                                                    options={budgetSource && budgetSource?.map((list) => (
                                                                                        <MenuItem key={list?.idBudget} value={list?.idBudget} >
                                                                                            {list?.budgetName}
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                />
                                                                            </div>
                                                                        </article>
                                                                        <article className='grid grid-cols-12 gap-2 mt-2'>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    disabled
                                                                                    placeholder='0.00'
                                                                                    onkeypress={handleTypingNumber}
                                                                                    required
                                                                                    value={budget?.projectBudget}
                                                                                    onchange={() => { }}
                                                                                    heading={t("งบประมาณโครงการ (บาท)")}
                                                                                />
                                                                            </span>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    disabled
                                                                                    placeholder='0.00'
                                                                                    onkeypress={handleTypingNumber}
                                                                                    required
                                                                                    value={budget?.equipmentBudget}
                                                                                    onchange={() => { }}
                                                                                    heading={t("งบประมาณครุภัณฑ์ (บาท)")}
                                                                                />
                                                                            </span>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    disabled
                                                                                    placeholder='0.00'
                                                                                    onkeypress={handleTypingNumber}
                                                                                    required
                                                                                    value={budget?.extraBudget}
                                                                                    onchange={() => { }}
                                                                                    heading={t("เงินโอนเพิ่มงบประมาณ (บาท)")}
                                                                                />
                                                                            </span>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    disabled
                                                                                    placeholder='0.00'
                                                                                    onkeypress={handleTypingNumber}
                                                                                    required
                                                                                    value={budget?.reducedBudget}
                                                                                    onchange={() => { }}
                                                                                    heading={t("เงินโอนลดงบประมาณ (บาท)")}
                                                                                />
                                                                            </span>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    disabled
                                                                                    placeholder='0.00'
                                                                                    style={{ backgroundColor: "#FFFAF2" }}
                                                                                    required
                                                                                    value={budget.sumBudget || numberFormat((revertFormatCurrency(budget.equipmentBudget.toString()) + revertFormatCurrency(budget.projectBudget.toString()) + revertFormatCurrency(budget.extraBudget.toString())) - revertFormatCurrency(budget.reducedBudget.toString()))}
                                                                                    onchange={() => { }}
                                                                                    heading={t("งบประมาณรวม (บาท)")}
                                                                                />
                                                                            </span>
                                                                        </article>
                                                                    </div>
                                                                ))}
                                                            </DetailAccordion>
                                                        </MainAccordion>


                                                    </section>
                                                )}

                                                {/* งบประมาณรวม  👇 */}
                                                <section className='w-full mt-2'>
                                                    {index === 0 && (
                                                        <article className='grid grid-cols-12 gap-2 mt-2'>
                                                            <span className='col-span-12 lg:col-span-2 self-end'>
                                                                <InputTextField
                                                                    disabled
                                                                    disableColor='#FFFAF2'
                                                                    value={`${formProject.tabs[index].sumAllBudget
                                                                        }`}
                                                                    heading={t("งบประมาณรวม (บาท)")}
                                                                />
                                                            </span>
                                                            <span className='col-span-12 lg:col-span-2 self-end'>
                                                                <InputTextField
                                                                    disabled
                                                                    disableColor='#FFEFEE'
                                                                    value={`${formProject.tabs[index].sumAllPaid
                                                                        }`}
                                                                    heading={t("ยอดเบิกจ่ายรวม (บาท)")}
                                                                />
                                                            </span>
                                                            <span className='col-span-12 lg:col-span-2 self-end'>
                                                                <InputTextField
                                                                    disabled
                                                                    disableColor='#ECF4FC'
                                                                    value={`${formProject.tabs[index].sumAllUnpaid
                                                                        }`}
                                                                    heading={t("ยอดงบประมาณค้างเบิก (บาท)")}
                                                                />
                                                            </span>
                                                        </article>
                                                    )}


                                                    {list?.detailResponsible?.map((responsible, i: number) => (
                                                        <>
                                                            <article key={i} className='grid grid-cols-12 gap-2 mt-2'>
                                                                <span className='col-span-12 lg:col-span-10 self-end'>
                                                                    {/* {employees && formProject && ( */}
                                                                    <AutocompleteSelect
                                                                        disabled
                                                                        required
                                                                        heading={`ผู้รับผิดชอบโครงการ${i === 0 ? 'หลัก' : 'ย่อย'}`}
                                                                        getOptionLabel={(option: any) => option && `${option?.employeeFirstname} ${option?.employeeLastname}`}
                                                                        labelId='EMPLOYEE'
                                                                        value={employees && employees?.find((list: any) => responsible?.idEmployee === list?.idEmployee) || null}
                                                                        onChange={() => { }}
                                                                        options={employees || []}
                                                                    />
                                                                    {/* )} */}
                                                                </span>
                                                                <span className='col-span-6 lg:col-span-2'>
                                                                    <InputTextField
                                                                        disabled
                                                                        disabledAutoComplete
                                                                        onkeypress={handleTypingNumber}
                                                                        required
                                                                        onchange={handleChangeDetailResponsible('percent', i, index)}
                                                                        value={responsible?.percent}
                                                                        heading={t("สัดส่วนที่รับผิดชอบ (%)")}

                                                                    />
                                                                </span>
                                                            </article>
                                                        </>
                                                    ))}


                                                    <article className='grid grid-cols-12 mt-2'>
                                                        <div className='col-span-12'>
                                                            <InputTextField
                                                                disabled
                                                                size='medium'
                                                                value={index === 0 ? list.projectDesc : list?.projectActivitiesDesc}
                                                                onchange={() => { }}
                                                                heading={t("รายละเอียดโครงการ")}
                                                            />
                                                        </div>
                                                    </article>
                                                </section>

                                                {/* ตัวชี้วัดประเมินผลโครงการ  👇 */}
                                                <article className='w-full mt-8'>
                                                    <div className='w-full'>
                                                        <Typography className='text-primary' variant='h4'>
                                                            {t("ตัวชี้วัดประเมินผลโครงการ")}
                                                        </Typography>
                                                    </div>

                                                    {/* TABS */}
                                                    <section className='w-full mt-2'>
                                                        <Box className='flex flex-col justify-start items-start gap-2 md:flex-row md:justify-between md:items-end'>
                                                            <Tabs
                                                                TabIndicatorProps={{ sx: { backgroundColor: colors.white } }}
                                                                value={indicatorTabs}
                                                                onChange={handleChangeIndicatorTabs}
                                                                aria-label="indicators-tabs">
                                                                {list.detailIndicators.map((list, i: number) => (
                                                                    <CustomTab
                                                                        label={
                                                                            <div>
                                                                                <Typography>{`ตัวชี้วัดเรื่องที่ ${i + 1}`}</Typography>
                                                                            </div>
                                                                        }  {...indicatorTabsProps(i)} />
                                                                ))}
                                                            </Tabs>
                                                        </Box>

                                                        <Box className='bg-bg_secondary w-full mt-2'>
                                                            {list && list.detailIndicators.map((indicator, indexDetail: number) => (
                                                                <IndicatorCustomTabPanel value={indicatorTabs} index={indexDetail}>
                                                                    <>
                                                                        <article className='grid grid-cols-12 gap-2'>
                                                                            <span className='col-span-12 lg:col-span-10'>
                                                                                <AutocompleteSelect
                                                                                    disabled
                                                                                    noOptionsText={t("ไม่พบข้อมูล")}
                                                                                    freeSolo
                                                                                    loading
                                                                                    required
                                                                                    heading={`เรื่อง`}
                                                                                    onInputChange={() => { }}
                                                                                    inputValue={indicator.indicatorsName}
                                                                                    getOptionLabel={(option: any) => `${option?.indicatorsName}`}
                                                                                    labelId='INDICATOR_NAME'
                                                                                    value={indicators && indicators?.find((list: any) => indicator?.idIndicators === list?.idIndicators) || null}
                                                                                    onChange={() => { }}
                                                                                    options={indicators || []}
                                                                                />
                                                                            </span>
                                                                            <span className='col-span-12 lg:col-span-2'>
                                                                                <InputTextField
                                                                                    disabled
                                                                                    disabledAutoComplete
                                                                                    required
                                                                                    onchange={() => { }}
                                                                                    onkeypress={handleTypingNumber}
                                                                                    value={indicator?.percent}
                                                                                    heading={t("สัดส่วน (%)")}
                                                                                />
                                                                            </span>
                                                                        </article>
                                                                        <article className='w-full mt-3'>
                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 1' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        required
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min1}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required
                                                                                        disabled
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max1}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        onchange={() => { }}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description1}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>

                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 2' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        required
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min2}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        required
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max2}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        onchange={() => { }}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description2}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>

                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 3' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        required
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min3}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        required
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max3}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        onchange={() => { }}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description3}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>
                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 4' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        required
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min4}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        required
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max4}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        onchange={() => { }}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description4}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>
                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 5' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        required
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min5}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        required
                                                                                        onchange={() => { }}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max5}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        disabled
                                                                                        onchange={() => { }}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description5}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>
                                                                        </article>
                                                                    </>
                                                                </IndicatorCustomTabPanel>
                                                            ))}

                                                        </Box>
                                                    </section>
                                                </article>

                                            </CustomTabPanel>
                                        ))}
                                    </div>
                                </Box>
                            </article>

                        </motion.section>
                    </form>
                </styled.Content>
            </styled.MainContainer>
        </styled.ContainerHome >
    )
}

export default ViewProjectInformation